// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-n_hy","advertDetailService__price":"c-n_hz"};